import React from 'react';
import TimeAgo from 'react-timeago';
import { useTimeFormatter } from '@amzn/cuminuicomponents';

interface PostDateProps {
  createdAt: Date;
  updatedAt: Date | undefined;
  updatedByModerator: boolean
}

const PostDate: React.FC<PostDateProps> = ({ createdAt, updatedAt, updatedByModerator }) => {
  if (updatedAt && !!updatedByModerator) {
    return <TimeAgo minPeriod={30} date={updatedAt} formatter={useTimeFormatter('relativeTime_moderatorUpdate')} />;
  }
  if (updatedAt) {
    return <TimeAgo minPeriod={30} date={updatedAt} formatter={useTimeFormatter('relativeTime_updated')} />;
  }
  return <TimeAgo minPeriod={30} date={createdAt} formatter={useTimeFormatter()} />;
};

export default PostDate;
